// extracted by mini-css-extract-plugin
export default {"TechnologyPage":"TechnologyPage-module--TechnologyPage--35n9W"};